
 <button mat-button (click)="addNewCampaign()" ><i class="fa fa-plus"></i><span>New Campaign</span></button>

